import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "6b4fb6d0-0565-41f4-b194-143a00d4840f",
    content:
      "Wave-based models are mostly depending on accurate material properties and the resolution of the geometry mesh.",
    options: {},
  },
  {
    id: "a0c280d6-9912-4d0f-a197-f70b7cf8b111",
    content: "Curved surfaces are no problem in acoustical simulations.",
    options: {},
  },
  {
    id: "6935cc78-9171-40a0-9a75-62be712de2bb",
    content: "A good compromise between accuracy and complexity needs to be found.",
    options: {},
  },
];

export const task: Task = {
  id: "d1e62d8d-a5c4-4488-aba2-591365cb4823",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6b4fb6d0-0565-41f4-b194-143a00d4840f", "6935cc78-9171-40a0-9a75-62be712de2bb"],
};
